import { CodeBlock, dracula } from 'react-code-blocks';
import styles from './style.module.scss';

/** Questions arrive as plain text with markdown-style code markers. */
const CODE_FENCE = '```';
const INLINE_CODE = /(`.*?`)/g;

interface Props {
    number: number;
    text: string;
};

/** Renders a text fragment, turning its `inline code` into <code> elements. */
function InlineText({ text }: { text?: string }) {
    if (!text) return null;

    return <>
        {text.split(INLINE_CODE).map((part, index) => part.startsWith('`')
            ? <code key={index}>{part.slice(1, -1)}</code>
            : <span key={index}>{part}</span>)}
    </>
};

/** The question itself: leading text, an optional code snippet, then trailing text. */
function QuestionText(props: Props) {
    const { number, text } = props;
    const [intro, snippet, outro] = text.split(CODE_FENCE);

    return (
        <>
            <span className={styles.question}>
                {number} - <InlineText text={intro} />
            </span>
            {snippet !== undefined && <div className={styles.codeBlock}>
                <CodeBlock
                    text={snippet}
                    theme={dracula}
                    language='python'
                    showLineNumbers
                />
            </div>}
            <span className={styles.question}>
                <InlineText text={outro} />
            </span>
        </>
    )
};

export default QuestionText;
